import { Button } from "@/atoms-react/button/Button.react";
import Column from "@/atoms-react/column/Column.react";
import InputPhone, { type PhoneNumber } from "@/atoms-react/input/InputPhone.react";
import type { LayoutBaseProps } from "@/atoms-react/layout-base/LayoutBase.react";
import { FRENCH_CODE, FRENCH_CODE_SHORT } from "@/features/utils/constants";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { FlowHeader } from "../../../flow-header.react";
import { Checkbox } from "@/atoms-react/input-checkbox/index.react";
import { A } from "@/atoms-react/a/A.react";
import { usei18n } from "@/features/utils/hooks/use-i18n";
import { CGU_TYPE, type CguType } from "@/features/cgu/types";
import { Base } from "@/atoms-react/text/Text.react";

export type EnterPhoneOutput = {
  phone: PhoneNumber;
  cguItem: CguType;
};

interface EnterPhoneProps extends LayoutBaseProps {
  onValidated: (data: EnterPhoneOutput) => void;
  cguList: CguType[];
}

function EnterPhone({ onValidated, cguList }: EnterPhoneProps) {
  const { t } = useTranslation(["pass"]);
  const [cgu, setCgu] = useState(false);

  const [phone, setPhone] = useState<PhoneNumber>({
    phone: "",
    valid: false,
    international: "",
    countryCode: FRENCH_CODE,
    countryPrefix: "+33"
  });
  const { getLanguage } = usei18n();

  function execute() {
    const cgu = cguList.find((cgu: CguType) => cgu.Type === CGU_TYPE.REGISTER);

    // May the message would not fit cgu missing
    if (!phone?.phone || !phone?.valid || !cgu) {
      toast.error(t("flow.id_control.error.must_enter_fields"));
      return;
    }

    onValidated({
      phone: phone,
      cguItem: cgu
    });
  }

  return (
    <>
      <Column>
        <div className="mb-12 grow">
          <FlowHeader
            title={t("flow.id_control.signup.label.enter_phone_title")}
            description={t("flow.id_control.signup.label.enter_phone_description")}
          />
          <Base className="mb-2">{t("flow.id_control.signup.label.input_phone_label")}</Base>
          <InputPhone
            autoFocus
            value={phone}
            autoComplete="tel"
            onChange={(value) => setPhone(value)}
            initialCountry={FRENCH_CODE_SHORT}
          />

          <br />
          <br />
          <Checkbox value={cgu} onChange={(value) => setCgu(value)}>
            <span>
              {t("flow.id_control.signup.label.cgu_accept_1") + " "}
              <A
                href={
                  getLanguage() === "fr"
                    ? cguList?.find((cgu) => cgu.Type === CGU_TYPE.REGISTER)?.UrlFr
                    : cguList?.find((cgu) => cgu.Type === CGU_TYPE.REGISTER)?.UrlEn
                }
                target="_blank"
                rel="noreferrer"
                className="text-primary"
              >
                {t("flow.id_control.signup.label.cgu_accept_2_link")}
              </A>
              {t("flow.id_control.signup.label.cgu_accept_3")}
            </span>
          </Checkbox>
        </div>
        <Button
          disabled={!phone?.phone || !phone?.valid || !cgu}
          shortcut="enter"
          className="shrink-0"
          onClick={() => execute()}
          icon={<ChevronRightIcon />}
        >
          {t("flow.id_control.input.continue")}
        </Button>
      </Column>
    </>
  );
}

export default EnterPhone;
